// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://oysnmlogkevcqrprkwww.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im95c25tbG9na2V2Y3FycHJrd3d3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQyODc5ODYsImV4cCI6MjA3OTg2Mzk4Nn0.RPopsGzptKZDBBbaHWpNbEte-0nl0lzyAok5pMgCRTo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});